import { createFileRoute, useParams } from '@tanstack/react-router';
import { HolderLedgerPage } from '@/features/holders/holder-ledger-page.js';

function BankAccountLedgerRoute(): React.JSX.Element {
  const { id } = useParams({ from: '/_app/bank-accounts/$id/ledger' });
  return <HolderLedgerPage kind="BANK_ACCOUNT" id={id} />;
}

export const Route = createFileRoute('/_app/bank-accounts/$id/ledger')({
  component: BankAccountLedgerRoute,
});
